import { getRuntimeConfig } from '@24i/nxg-sdk-smartott/src/Application/initApp';
import { Storage } from '@24i/nxg-sdk-quantum';
import { log } from '@24i/nxg-core-utils/src/logger';
import { ASYNC_STORAGE_KEY_USER } from '@24i/nxg-core-utils/src/constants';
import { FlowIdRuntimeConfig, LogoutFlowIdConfig } from '../types';

export class FlowIDService {
    static async logout() {
        const openIdRuntimeConfig: FlowIdRuntimeConfig =
            getRuntimeConfig() as unknown as FlowIdRuntimeConfig;
        const userData = await FlowIDService.getUserDataFromStorage();

        if (openIdRuntimeConfig?.custom?.features?.logoutFlowId?.logoutUrl && userData?.id) {
            const { apiKey, userKey, secret, logoutUrl } =
                openIdRuntimeConfig.custom.features.logoutFlowId;

            const details: LogoutFlowIdConfig = {
                apiKey: apiKey || '',
                userKey: userKey || '',
                secret: secret || '',
                UID: userData.id,
            };

            await FlowIDService.makeLogoutApiCall(logoutUrl, details);
        }
    }

    static async makeLogoutApiCall(logoutUrl: string, details: LogoutFlowIdConfig) {
        const formBody = Object.entries(details)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&');

        try {
            await fetch(logoutUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                },
                body: formBody,
            });
        } catch (error) {
            log('Logout error:', error);
        }
    }

    static async getUserDataFromStorage() {
        try {
            const obj = await Storage.getItem(ASYNC_STORAGE_KEY_USER);
            return JSON.parse(obj || '');
        } catch (error) {
            log(error);
            return {};
        }
    }
}
